import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { listNotifications, getUnreadCount, markNotificationRead, markAllNotificationsRead, deleteNotification } from './api'

export function useNotifications(accountId: string, options: { refetchInterval?: number } = {}) {
  return useQuery({
    queryKey: ['notifications', accountId],
    queryFn: () => listNotifications(accountId, { limit: 50 }),
    enabled: !!accountId,
    staleTime: 10000,
    refetchInterval: options.refetchInterval,
  })
}

export function useUnreadCount(accountId: string) {
  return useQuery({
    queryKey: ['notifications', 'unread', accountId],
    queryFn: () => getUnreadCount(accountId),
    enabled: !!accountId,
    refetchInterval: 30000,
    staleTime: 10000,
  })
}

export function useMarkRead() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, accountId }: { id: string; accountId: string }) => markNotificationRead(id, accountId),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ['notifications'] }) },
  })
}

export function useMarkAllRead() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (accountId: string) => markAllNotificationsRead(accountId),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ['notifications'] }) },
  })
}

export function useDeleteNotification() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, accountId }: { id: string; accountId: string }) => deleteNotification(id, accountId),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ['notifications'] }) },
  })
}
